const courses = [
    {
        id: "1",
        category: "IELTS Academic",
        image: '/images/IELTSAcademic.jpeg',
        course_name: "Mastering IELTS Academic: A Comprehensive Guide to Excel in the Test",
        description: "In this course, you will acquire the essential skills and strategies needed to excel in the IELTS Academic test, enabling you to pursue higher education and professional opportunities.The modified course focuses on helping students prepare for the IELTS Academic test by providing comprehensive training in all four modules: Listening, Reading, Writing, and Speaking. It also includes test-taking strategies, vocabulary building, and ample practice opportunities to ensure students are well-prepared for the exam.",
        rating_count: 963,
        rating_star: 4.5,
        students: 11848,
        creator: "Deepak Shukla",
        updated_date: "4/2022",
        lang: "english",
        actual_price: 40.99,
        discounted_price: 10.99,
        what_you_will_learn: [
        "Enhance your Listening, Reading, Writing, and Speaking skills for the IELTS Academic test.",
        "Familiarize yourself with the test format and gain valuable test-taking strategies.",
        "Develop effective time management techniques to optimize performance during the exam.",
        "Expand your academic vocabulary and language proficiency.",
        "Practice with sample questions and mock tests to assess your progress.",
        "Receive personalized feedback and tips for improvement.",
        ],
        content: [
        "Introduction to IELTS Academic and Test Overview",
        "Listening Module: Techniques and Practice Sessions",
        "Reading Module: Strategies and Practice Exercises",
        "Writing Module: Task 1 and Task 2 Preparation",
        "Speaking Module: Practice and Speaking Tips",
        "Mock Tests and Performance Evaluation",
        "IELTS Exam-Day Tips and Final Preparation",
        ],
        course_files: [
            {
              file_name: "Sample File 1",
              file_url: "files/ACADEMIC WRITING DAY 1.docx",
            },
            {
              file_name: "Sample File 2",
              file_url: "/files/ACADEMIC WRITING DAY 2.docx",
            },
        ]
        },

        {
            id: "2",
            category: "IELTS General",
            image: '/images/IELTS_general.png',
            course_name: "Ace the IELTS General Test: Your Path to Success",
            description: "This course is designed to equip you with the necessary skills and techniques to excel in the IELTS General test, enabling you to fulfill immigration, work, and study requirements in English-speaking countries.The modified course is tailored to help students prepare for the IELTS General test, which is required for immigration, work, and study purposes in English-speaking countries. The course covers all four modules: Listening, Reading, Writing, and Speaking, and offers strategies, grammar, and vocabulary improvement, as well as ample practice opportunities to ensure students' success in the IELTS General test.",
            rating_count: 845,
            rating_star: 4.2,
            students: 10234,
            creator: "Deepak Shukla",
            updated_date: "5/2022",
            lang: "english",
            actual_price: 38.99,
            discounted_price: 9.99,
            what_you_will_learn: [
            "Enhance your Listening, Reading, Writing, and Speaking skills for the IELTS General test.",
            "Understand the test format and gain valuable strategies for each section of the exam.",
            "Improve your grammar and vocabulary for better communication.",
            "Learn how to interpret and respond to different question types effectively.",
            "Practice with real IELTS General test materials and receive detailed feedback.",
            "Develop time management techniques to maximize your performance on the test.",
            ],
            content: [
            "Introduction to IELTS General Training and Test Format",
            "Listening Module: Strategies and Practice Sessions",
            "Reading Module: Techniques and Practice Exercises",
            "Writing Module: Letter and Essay Writing Skills",
            "Speaking Module: Fluency and Confidence Building",
            "Mock Tests and Performance Evaluation",
            "Tips for Test Day and Final Preparation",
            ],
            course_files: [
                {
                  file_name: "Sample File 1",
                  file_url: "/files/ACADEMIC WRITING DAY 1.docx",
                },
                {
                  file_name: "Sample File 2",
                  file_url: "/files/ACADEMIC WRITING DAY 2.docx",
                },
            ]
            }
]

/*const courses = [
    {
        id: "xMHCZl",
        category: "python",
        image: '/images/data_science_1.jpg',
        course_name: "Learn Python: The Complete Python Programming Course",
        description: "Learn A-Z everything about Python, from the basics, to advanced topics like Python GUI, Python Data Analysis, and more!",
        rating_count: 3059,
        rating_star: 4.4,
        students: 18430,
        creator: "Avinash Jain, The Codex",
        updated_date: "9/2015",
        lang: "english",
        actual_price: 84.99,
        discounted_price: 9.99,
        what_you_will_learn: [
            "Create their own Python Programs",
            "Become an experienced Python Programmer",
            "Parse the Web and Create their own Games"
        ],
        content: [
            "Up and Running With Python",
            "The Basics(Data Types)",
            "Conditions and Loops",
            "Functions!",
            "Classes! (Object Oriented Programming)",
            "File Input/Output",
            "Using Python Modules"
        ]
    },
    {
        id: "dtfo9e",
        category: "python",
        image: '/images/data_science_1.jpg',
        course_name: "Learning Python for Data Analysis and Visualization",
        description: "Learn python and how to use it to analyze,visualize and present data. Includes tons of sample code and hours of video!",
        rating_count: 3059,
        rating_star: 4.3,
        students: 184053,
        creator: "Jose Portilla",
        updated_date: "9/2019",
        lang: "english",
        actual_price: 84.99,
        discounted_price: 9.99,
        what_you_will_learn: [
            "Have an intermediate skill level of Python programming.",
            "Use the numpy library to create and manipulate arrays.",
            "Learn how to work with various data formats within python, including: JSON,HTML, and MS Excel Worksheets.",
            "Have a portfolio of various data analysis projects."
        ],
        content: [
            "Intro to Course and Python",
            "Learning Numpy",
            "Data Visualization",
            "Example Projects",
            "Machine Learning",
            "SQL and Python",
            "Web Scraping with Python"
        ]
    },
    {
        id: "fLroW6",
        category: "python",
        image: '/images/data_science_1.jpg',
        course_name: "Python for Beginners - Learn Programming from scratch",
        description: "Python For Beginners : This course is meant for absolute beginners in programming or in python!",
        rating_count: 1844,
        rating_star: 4.3,
        students: 7330,
        creator: "Edwin Diaz, Coding Faculty Solutionss",
        updated_date: "5/2022",
        lang: "english",
        actual_price: 84.99,
        discounted_price: 9.99,
        what_you_will_learn: [
            "To learn the python language",
            "To learn the CORE skills to understand any programming language",
        ],
        content: [
            "Programming fundamentals",
            "Getting Started with Python",
            "Python Basics",
            "Conditional structures",
            "Functions",
            "Working with files",
        ]
    },
    {
        id: "VwkN_o",
        category: "python",
        image: '/images/data_science_1.jpg',
        course_name: "Python For Beginners : This course is meant for absolute beginners in programming or in python.",
        description: "Python introduction for beginners. Learn complete Python from scratch!",
        rating_count: 2780,
        rating_star: 4.3,
        students: 29082,
        creator: "Abrar Hussain",
        updated_date: "9/2019",
        lang: "english",
        actual_price: 29.99,
        discounted_price: 9.99,
        what_you_will_learn: [
            "Create fully functional Python programs",
            "Learn about loop structures and conditionals",
            "Work with Python file handling",
            "Manipulate strings and data"
        ],
        content: [
            "Getting Started",
            "The Basics",
            "User Input",
            "Functions and Files",
            "Classes and Objects",
            "Graphics and Animations",
        ]
    },
    {
        id: "xJB-WU",
        category: "python",
        image: '/images/data_science_1.jpg',
        course_name: "Python Beyond the Basics - Object-Oriented Programming",
        description: "From Classes To Inheritance - OOP In-Depth For Python Programmers",
        rating_count: 2941,
        rating_star: 4.2,
        students: 10450,
        creator: "Infinite Skills",
        updated_date: "9/2019",
        lang: "english",
        actual_price: 49.99,
        discounted_price: 10.99,
        what_you_will_learn: [
            "Design Reusable Object-Oriented Python Classes",
            "How to handle Errors",
            "Work with Python file handling",
            "Apply OOP Concepts to handle complexity"
        ],
        content: [
            "Introduction to Object Oriented Python",
            "Classes",
            "Inhertiance and Polymorphism",
            "Advanced Features",
            "Object Serialization",
            "Efficiency and testing",
            "Conclusion"
        ]
    },
    {
        id: "qjdYG4",
        category: "web development",
        image: '/images/data_science_1.jpg',
        course_name: "Become a Certified HTML, CSS, JavaScript Web Developer",
        description: "Complete coverage of HTML, CSS, Javascript while you Earn Four Respected Certifications",
        rating_count: 2760,
        rating_star: 4.1,
        students: 33455,
        creator: "Tech Learning Network, Mark Lassoff",
        updated_date: "11/2020",
        lang: "english",
        actual_price: 84.99,
        discounted_price: 9.99,
        what_you_will_learn: [
            "Prepare for Industry Certification Exam",
            "Hours and Hours of Video Instruction",
            "Over 25 Engaging Lab Exercises",
            "Instructor Available by Email or on the Forums",
            "Comprehensive Coverage of HTML and CSS"
        ],
        content: [
            "Your Develpment Toolbox",
            "Certified HTML5 Specialist 2019",
            "Certified CSS Specialist 2019",
            "JavaScript Specialist 2019",
            "jQuery for Application Development",
            "Everything you wanted to know about formatting text",
            "Hyperlinks - Connecting Pages and Content",
            "Digital Media",
            "Displaying Data in Tables and iFrames",
            "Styling with CSS"
        ]
    },
    {
        id: "3pm9Ab",
        category: "web development",
        image: '/images/data_science_1.jpg',
        course_name: "The Complete 2020 Fullstack Web Developer Course",
        description: "Learn HTML5, CSS3, JavaScript, Python, Wagtail CMS, PHP & MySQL from scratch!",
        rating_count: 6200,
        rating_star: 4.3,
        students: 90360,
        creator: "Kalob Taulien",
        updated_date: "9/2019",
        lang: "english",
        actual_price: 72.99,
        discounted_price: 14.99,
        what_you_will_learn: [
            "Learn Python from beginner to advanced",
            "Lots of projects, big and small!",
            "Learn PHP for server code execution",
            "Build a Login/Registration/Members-only website, just like Facebook",
            "Learn the LAMP Stack: Linux, Apache, PHP and MySQL",
            "Learn HTML5, CSS3, Vanilla JS (ES6+), Python, Wagtail CMS, PHP and MySQL all from scratch"
        ],
        content: [
            "The Ultimate HTML Developer: Introduction",
            "Getting Started",
            "Advanced HTML",
            "Text Formatting",
            "Fonts and Font styling",
            "Links and their 'states'",
            "Better selectors",
            "Positions",
            "Advanced Selectors",
            "CSS3 Introduction",
            "CSS3 Backgrounds Images",
            "CSS3 Gradients",
            "CSS3 Text Formatting",
            "CSS3 Transitions",
            "CSS3 Animations",
            "CSS3 Flexbox",
            "Responsive Web Design"
        ]
    },
    {
        id: "RuUs0x",
        category: "web development",
        image: '/images/data_science_1.jpg',
        course_name: "Introduction to Web Development",
        description: "Are you Interested in Learning Web Development? Enroll in this Free course for a Dynamic Introduction to the Profession!",
        rating_count: 1740,
        rating_star: 4,
        students: 22309,
        creator: "Tech Learning Network, Mark Lassoff",
        updated_date: "10/2020",
        lang: "english",
        actual_price: 19.99,
        discounted_price: 8.99,
        what_you_will_learn: [
            "Understand the technologies used in web development",
            "Apply HTML document structure",
            "Add images to a web page",
            "Understand the HTML/CSS color model",
            "Alter CSS text properties",
            "Know the role of Javascript programming in web development",
            "Create a basic Javascript program to collect data",
            "Understand the next steps to learning professional web development skills"
        ],
        content: [
            "Tools and HTML",
            "CSS",
            "Javascript",
            "Bonus Lecture",
        ]
    },
    {
        id: "e_0hBc",
        category: "web development",
        image: '/images/data_science_1.jpg',
        course_name: "Running a Web Development Business: The Complete Guide",
        description: "Learn how to start and grow a successful web development business. Get up & running and making sales in under a week.",
        rating_count: 1577,
        rating_star: 4.8,
        students: 33100,
        creator: "Evan Kimbrell",
        updated_date: "8/2022",
        lang: "english",
        actual_price: 70.99,
        discounted_price: 14.99,
        what_you_will_learn: [
            "Understand how development stacks work and pick which stack is ideal for you",
            "Decide between hiring in-house employees or contractors for your business",
            "Choose a winning combination of traits that you want your business to convey",
            "Find cheap and professional ways of creating an online presence",
            "Master the biggest platforms for contracting: Freelancer and Upwork",
            "Create and organize a professional and effective portfolio",
            "Utilize 15 different strategies to attract potential clients",
            "Use tools like Proposify and Nusii to create and streamline proposals"
        ],
        content: [
            "Introduction",
            "The Essentials",
            "Planning your strategy",
            "Setting up your presence",
            "Finding subcontractors",
            "Building a portfolio",
            "Getting clients",
            "Building proposals",
            "Managing clients",
            "Best practices"
        ]
    },
    {
        id: "z9dxdw",
        category: "web development",
        image: '/images/data_science_1.jpg',
        course_name: "Ultimate Web Designer & Web Developer Course",
        description: "Become a Full-Stack Web Designer in 2022 - Learn Everything from Web Design Fundamentals to Front-End Web Development",
        rating_count: 2941,
        rating_star: 4.6,
        students: 10450,
        creator: "Brad Hussey",
        updated_date: "3/2022",
        lang: "english",
        actual_price: 50.99,
        discounted_price: 11.99,
        what_you_will_learn: [
            "Build 23+ custom web design & development projects by hand",
            "Plan, design and code your very own self-directed website project from scratch to launch!",
            "Code websites & applications with HTML5 & CSS3",
            "Comfortably use Adobe Photoshop for photo manipulation, graphics creation & design",
            "Design a professional and modern business card in Adobe Photoshop",
            "Learn visual design fundamentals for beginners",
            "Learn how to choose the correct font combinations for your projects",
            "Design, build and manage custom database-driven websites with MySQL"
        ],
        content: [
            "Hey! Welcome to the course!",
            "Introduction to Visual Design for Web Designers & Web Developers",
            "Designing Websites, Graphics & Interfaces with Figma",
            "Introduction to Adobe Photoshop",
            "Introduction to Web Design (and more Photoshop)",
            "Advanced Web Design Challenge",
            "Introduction to HTML",
            "Intermediate HTML",
            "Advanced HTML & HTML5",
            "Expert HTML & HTML5"
        ]
    },
    {
        id: "X8Pg1X",
        category: "data science",
        image: '/images/data_science_1.jpg',
        course_name: "Data Science A-Z™: Real-Life Data Science Exercises Included",
        description: "Learn Data Science step by step through real Analytics examples. Data Mining, Modeling, Tableau Visualization and more!",
        rating_count: 32103,
        rating_star: 4.5,
        students: 204985,
        creator: "Kirill Eremenko, Ligency Team",
        updated_date: "9/2022",
        lang: "english",
        actual_price: 77.99,
        discounted_price: 16.99,
        what_you_will_learn: [
            "Successfully perform all steps in a complex Data Science project",
            "Perform Data Mining in Tableau",
            "Apply Ordinary Least Squares method to Create Linear Regressions",
            "Assess the Adjusted R-Squared for all types of models",
            "Create a Multiple Linear Regression (MLR)",
            "Interpret coefficients of an MLR",
            "Use Backward Elimination, Forward Selection, and Bidirectional Elimination methods to create statistical models",
            "Read a Confusion Matrix"
        ],
        content: [
            "What is Data Science?",
            "Part 1: Visualisation",
            "Introduction to Tableau",
            "Advanced Data Mining with Tableau",
            "Stats Refresher",
            "Simple Linear Regression",
            "Model maintenance",
            "SQL Programming for Data Science",
        ]
    },
    {
        id: "9Ui0L1",
        category: "data science",
        image: '/images/data_science_1.jpg',
        course_name: "Machine Learning, Data Science and Deep Learning with Python",
        description: "Complete hands-on machine learning tutorial with data science, Tensorflow, artificial intelligence, and neural networks",
        rating_count: 27687,
        rating_star: 4.5,
        students: 166929,
        creator: "Sundog Education by Frank Kane",
        updated_date: "2/2022",
        lang: ["english", "french"],
        actual_price: 87.99,
        discounted_price: 14.99,
        what_you_will_learn: [
            "Build artificial neural networks with Tensorflow and Keras",
            "Classify images, data, and sentiments using deep learning",
            "Data Visualization with MatPlotLib and Seaborn",
            "Classify data using K-Means clustering, Support Vector Machines (SVM), KNN, Decision Trees, Naive Bayes, and PCA",
            "Build a movie recommender system using item-based and user-based collaborative filtering",
            "Interpret coefficients of an MLR",
        ],
        content: [
            "Statistics and Probability Refresher, and Python Practice",
            "Predictive Models",
            "Machine Learning with Python",
            "Recommender Systems",
            "More Data Mining and Machine Learning Techniques",
            "Dealing with Real-World Data",
            "Apache Spark: Machine Learning on Big Data",
            "Deep Learning and Neural Networks",
        ]
    },
    {
        id: "TKGumi",
        category: "data science",
        image: '/images/data_science_1.jpg',
        course_name: "Data Science: Deep Learning and Neural Networks in Python",
        description: "The MOST in-depth look at neural network theory for machine learning, with both pure Python and Tensorflow code",
        rating_count: 8513,
        rating_star: 4.8,
        students: 50184,
        creator: "Lazy Programmer Inc.",
        updated_date: "8/2022",
        lang: ["english", "Portuguese"],
        actual_price: 90.99,
        discounted_price: 19.99,
        what_you_will_learn: [
            "Learn how Deep Learning REALLY works (not just some diagrams and magical black box code)",
            "Code a neural network from scratch in Python and numpy",
            "Describe different types of neural networks and the different types of problems they are used for",
            "Create a neural network with an output that has K > 2 classes using softmax",
            "Install TensorFlow",
        ],
        content: [
            "Preliminaries: From Neurons to Neural Networks",
            "Training a neural network",
            "Practical Machine Learning",
            "TensorFlow, exercises, practice, and what to learn next",
            "Project: Facial Expression Recognition",
            "Backpropagation Supplementary Lectures",
            "Higher-level Discussion",
        ]
    },
    {
        id: "oETsMx",
        category: "data science",
        image: '/images/data_science_1.jpg',
        course_name: "R Programming A-Z™: R For Data Science With Real Exercises!",
        description: "Learn Programming In R And R Studio. Data Analytics, Data Science, Statistical Analysis, Packages, Functions, GGPlot2",
        rating_count: 47264,
        rating_star: 4.8,
        students: 237914,
        creator: "Kirill Eremenko, Ligency Team",
        updated_date: "11/2021",
        lang: "english",
        actual_price: 45.99,
        discounted_price: 6.99,
        what_you_will_learn: [
            "Learn to program in R at a good level",
            "Learn the core principles of programming",
            "Learn how to create variables",
            "Learn how to create a while() loop and a for() loop in R",
            "Learn the matrix() function, learn rbind() and cbind()",
            "Learn how to customize R studio to suit your preferences"
        ],
        content: [
            "Hit The Ground Running",
            "Core Programming Principles",
            "Fundamentals of R",
            "Matrices",
            "Data Frames",
            "Advanced Visualization with GGPlot2",
            "Homework Solutions",
        ]
    },
    {
        id: "-aWjaj",
        category: "data science",
        image: '/images/data_science_1.jpg',
        course_name: "Data Science and Machine Learning Bootcamp with R",
        description: "Learn how to use the R programming language for data science and machine learning and data visualization!",
        rating_count: 32103,
        rating_star: 5,
        students: 204985,
        creator: "Jose Portilla",
        updated_date: "12/2020",
        lang: ["english", "arabic"],
        actual_price: 77.99,
        discounted_price: 16.99,
        what_you_will_learn: [
            "Program in R",
            "Create Data Visualizations",
            "Use R to manipulate data easily",
            "Use R for Data Science",
            "Use R for Data Analysis",
            "Use R to handle csv,excel,SQL files or web scraping",
            "Use R for Machine Learning Algorithms"
        ],
        content: [
            "Course Best Practices",
            "Windows Installation Set-Up",
            "Mac OS Installation Set-Up",
            "Linux Installation",
            "Development Environment Overview",
            "Introduction to R Basics",
            "R Data Frames",
        ]
    },
    {
        id: "xxxbMD",
        category: "aws",
        image: '/images/data_science_1.jpg',
        course_name: "Amazon Web Services (AWS) Certified 2022 - 4 Certifications!",
        description: "Videos, labs & practice exams - AWS Certified (Solutions Architect, Developer, SysOps Administrator, Cloud Practitioner)",
        rating_count: 21046,
        rating_star: 4.2,
        students: 134932,
        creator: "BackSpace Academy, Paul Coady",
        updated_date: "12/2021",
        lang: ["english", "arabic"],
        actual_price: 69.99,
        discounted_price: 11.99,
        what_you_will_learn: [
            "You will be fully prepared for the",
            "AWS Certified Solutions Architect",
            "Associate, AWS Certified Developer",
            "Associate and AWS Certified SysOps ...",
        ],
        content: [
            "AWS Cerified Cloud Practitioner",
            "AWS Certified Associate Core Knowledge",
            "AWS Certified Developer Associate - Final Preparation",
            "AWS Certified Solutions Architect Associate - Final Preparation",
            "AWS Certified SysOps Administrator Associate - Final Preparation",
        ]
    },
    {
        id: "cIdBd2",
        category: "aws",
        image: '/images/data_science_1.jpg',
        course_name: "AWS Certified Security Specialty 2022",
        description: "All you need to master AWS Certified Security Specialty certification.",
        rating_count: 5387,
        rating_star: 4.5,
        students: 33385,
        creator: "Zeal Vora",
        updated_date: "12/2022",
        lang: ["english", "french"],
        actual_price: 34.99,
        discounted_price: 10.99,
        what_you_will_learn: [
            "Will be prepared to give AWS Certified Security Specialty Exam",
            "Gain deep insights about Enterprise grade Security implementation.",
            "You will be able to Master the Security aspect of AWS",
            "Will be able to detect attacks and protect the AWS infrastructure from Hackers.",
        ],
        content: [
            "Getting started with the course",
            "Domain 1 - Incident Response",
            "Domain 2 - Logging & Monitoring",
            "Domain 3 - Infrastructure Security",
            "Domain 4 - Identity & Access Management",
            "Domain 5 - Data Protection"
        ]
    },
    {
        id: "NkZeqm",
        category: "aws",
        image: '/images/data_science_1.jpg',
        course_name: "Part 1: AWS Certified Solutions Architect SAA C03 [Updated]",
        description: "AWS Associate Exam - Master Foundations. Join Live Study Group Q&A!",
        rating_count: 1603,
        rating_star: 4.5,
        students: 10933,
        creator: "Chandra Lingam",
        updated_date: "8/2022",
        lang: "english",
        actual_price: 71.99,
        discounted_price: 15.99,
        what_you_will_learn: [
            "Breadth of understanding of various AWS services",
            "How to Integrate Services into a Complete Solution",
            "Hands-on Scenario Based Learning",
            "Weekly Study Group Discussion Sessions",
            "Concise and Precise Preparation for AWS Solutions Architect Certification"
        ],
        content: [
            "Housekeeping",
            "Infrastructure, Pricing, Support - Review",
            "Networking Primer",
            "Virtual Private Cloud (VPC) - Networking Infrastructure",
            "Elastic Compute Cloud (EC2) - Compute Service",
            "Monitoring Resource in Cloud"
        ]
    },
    {
        id: "NkZeqq",
        category: "design",
        image: '/images/data_science_1.jpg',
        course_name: "Photoshop Master Course: From Beginner to Photoshop Pro",
        description: "This Adobe Photoshop Beginner Course will teach a Beginner Photoshop user all essentials of Adobe Photoshop CC",
        rating_count: 5066,
        rating_star: 4.9,
        students: 143812,
        creator: "Manfred Werner",
        updated_date: "7/2020",
        lang: ["english", "spanish"],
        actual_price: 13.99,
        discounted_price: 5.99,
        what_you_will_learn: [
            "What Photoshop is & how to get into it!",
            "Customize the programs layout & feel comfortable",
            "Understand layers & it's panels",
            "Understand adjustment layers how to use them",
            "Understand setting color profiles, save PSD files & web files",
            "Understand cutting objects out, fixing skin & manipulation"
        ],
        content: [
            "Photoshop Interface & Workspace - For Beginners",
            "Important Photoshop Tools - For Beginners",
            "Retouching Class - Photoshop Portrait Retouching Course",
            "Retouching Class 2 - Photoshop Portrait Retouching Course",
            "Retouching Class 3 - The Instagramer",
            "Bonus Lectures"
        ]
    },
    {
        id: "bLZepe",
        category: "design",
        image: '/images/data_science_1.jpg',
        course_name: "User Experience (UX): The Ultimate Guide to Usability and UX",
        description: "Get a job in UX and build your user research and UX design skills with this hands-on user experience training course.",
        rating_count: 6250,
        rating_star: 4.4,
        students: 22090,
        creator: "David Travis",
        updated_date: "4/2020",
        lang: ["english", "italian"],
        actual_price: 79.99,
        discounted_price: 16.99,
        what_you_will_learn: [
            "Bake UX into your workflow by following a proven, user centred design framework.",
            "Moderate a usability test and prioritise the observations.",
            "Uncover and describe users’ mental models.",
            "Design and conduct online and offline card sorting sessions.",
            "Develop cheap, throwaway prototypes to get quick and frequent feedback from your users."
        ],
        content: [
            "Going where the action is: Understading users in context",
            "How to get niche quick",
            "UX Design Activities - Build your UX Portfolio",
            "What can a London bus teach us about usability?",
            "Beyong 'easy to use': Measuring the user experience",
            "Site structure and navigation: Finding is the new doing",
            "Interaction design: Simple rules for designing simple screens"
        ]
    },
    {
        id: "RkZecd",
        category: "marketing",
        image: '/images/data_science_1.jpg',
        course_name: "Copywriting - Become a Freelance Copywriter, your own boss",
        description: "Build a successful freelance copywriting business - turn basic writing skills into a paycheck.",
        rating_count: 2779,
        rating_star: 4.8,
        students: 32657,
        creator: "Len Smith, Sean Kaye",
        updated_date: "4/2018",
        lang: "english",
        actual_price: 88.99,
        discounted_price: 16.99,
        what_you_will_learn: [
            "Part one – everything you need for a fast-track start, including your first article",
            "Part three – the essential skills that mark out a real pro",
            "Part two – the copywriter’s ‘how to’: sales copy, expert copy, and more!",
            "Part four – how to boost your income and turn your new website into a money magnet",
        ],
        content: [
            "Choose projects whre you feel comfortable",
            "Back to basics II",
            "How to boost your copywriting income",
            "More on pricing your work",
            "This and that",
            "Conclusion"
        ]
    },
    {
        id: "NrZ_qd",
        category: "marketing",
        image: '/images/data_science_1.jpg',
        course_name: "How to Market Yourself as a Coach or Consultant",
        description: "Learn a Proven, Step-by-Step Process You Can Use to Package, Brand, Market, & Sell Your Coaching or Consulting Services",
        rating_count: 963,
        rating_star: 3.8,
        students: 11848,
        creator: "Debbie LaChusa",
        updated_date: "4/2022",
        lang: "english",
        actual_price: 40.99,
        discounted_price: 10.99,
        what_you_will_learn: [
            "Identify who your Ideal Clients are so you know exactly who to market and sell to",
            "Learn how to create a Signature Program so you can stop selling your time or creating spec proposals",
            "Learn how to write Compelling Marketing Copy you can use to attract your ideal clients",
            "Learn how to create a Financially Viable Business and understand exactly what it will take to reach your financial goals",
            "Learn how to easily create your own Wordpress Coaching or Consulting Website"
        ],
        content: [
            "Building Your Business & Marketing Foundation",
            "Packaging Your Services",
            "Branding Yourself & Your Business",
            "Marketing Message Development",
            "Getting clients: Objectives & strategies",
            "Markting Yourself Online: Website Development",
            "Marketing Implementation: Create a 90-Day Marketing Plan",
        ]
    },
]; */

export default courses;